import { render, staticRenderFns } from "./25500005.vue?vue&type=template&id=48c06ece&scoped=true&"
import script from "./25500005.vue?vue&type=script&lang=js&"
export * from "./25500005.vue?vue&type=script&lang=js&"
import style0 from "./25500005.vue?vue&type=style&index=0&id=48c06ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c06ece",
  null
  
)

export default component.exports